import React, { useEffect, useState } from "react";
import Header from '../../common/Header'
import Sidebar from '../../common/Sidebar'
import Footer from '../../common/Footer'
import PageHeader from '../../pages/PageHeader'
import axios from "axios";
import { triggerAlert } from '../../utils';
import DataTable from 'react-data-table-component';
import { Modal, ModalBody } from "react-bootstrap";
import { useForm, } from 'react-hook-form';
import { MenuItem, Select, OutlinedInput, Chip, FormControl, Checkbox, ListItemText, Menu } from "@mui/material";
import { FaEyeSlash } from "react-icons/fa";
import Cookies from 'js-cookie';
import dayjs from "dayjs";
export default function Promocodes() {
    document.title = "Digital Employees - Promocodes"
    const mainHeading = "Promocodes";
    const heading = "Settings / Promocodes";
    const { register: registerForm, handleSubmit: handleSubmitForm, formState: { errors: errorsForm }, setValue: setValueForm, reset: resetForm, clearErrors, setError, getValues, trigger } = useForm();
    const [isEditing, setIsEditing] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [Data, setData] = useState([]);
    const [Createrole, setCreaterole] = useState(false);
    const [message, setMessage] = useState("Create");
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState('')
    const [edit, isedit] = useState(false)
    const [SelectedId, setSelectedId] = useState("")
    const [plans, setPlans] = useState([])
    const [selectedPlans, setSelectedPlans] = useState([])

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedidData, setselectedidData] = useState({})
    const [SelectedStatus, setSelectedStatus] = useState(false)

    const handleClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(row.id)
        setselectedidData(row)
        setSelectedStatus(row.is_active)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    console.log(SelectedId, 'seuihuiwhduih');

    useEffect(() => {
        fetchPlans()
    }, [])

    const fetchPlans = async () => {

        const res = await axios.get(`/api/admin/add-subscription-plan/?is_deleted=False&is_free=False`)

        if (res.status === 200) {
            setPlans(res.data.results)
        }
    }


    const fetchListData = async (page, size = perPage, searchkey) => {
        setIsLoading(true);
        try {
            // let token = sessionStorage.getItem("admin_user_token")
            let token = Cookies.get("admin_user_token");
            const response = await axios.get(`/api/admin/promo-codesv2/?limit=${size}&offset=${(page - 1) * perPage}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const response_data = response.data
            console.log(response_data, 'response_data.result');
            if (response.status === 200) {
                setIsLoading(false);
                setIsEditing(false);
                setTotalRows(response_data.count || response_data.length);

                const itemsArray = Array.isArray(response_data) ? response_data : response_data.results || [];

                const formattedData = itemsArray.map((item, i) => ({
                    ...item,
                    Num: i + 1
                }));

                setData(formattedData);
            } else if (response.status === 204) {
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: row => row.Num,
            sortable: true,
            center: true,
            width: "100px"
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Coupon Code',
            selector: row => row.code,
            sortable: true,
            center: true,
        },
        {
            name: 'Discount',
            selector: row => `${row.discount_type === 'percentage' ? '' : '$'}${parseFloat(row.discount_value).toFixed(0)}${row.discount_type === 'percentage' ? '%' : ''}`,
            sortable: true,
            center: true,
        },
        {
            name: 'Redemptions',
            selector: row => `${row.times_redeemed} / ${row.max_redemptions || '∞'}`,
            sortable: true,
            center: true,
        },
        {
            name: 'Min. Amount',
            selector: row => `$${row.minimum_amount || '0.00'}`,
            sortable: true,
            center: true,
        },
        {
            name: 'Validity',
            selector: row => row.valid_until,
            cell: row => (
                <div className="font_12">
                    <div>{row.valid_from ? dayjs(row.valid_from).format('MM-DD-YY') : 'Any'}</div>
                    <div className="text-muted">to</div>
                    <div>{row.valid_until ? dayjs(row.valid_until).format('MM-DD-YY') : 'Forever'}</div>
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.is_active,
            cell: row => (
                <span className={`btn btn-sm btn-rounded ${row.is_active ? 'btn-success activebtn' : 'btn-danger Inactivebtn'}`}>
                    {row.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <>

                    <div>
                        <div
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? 'long-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleClick(event, row)}
                        >
                            <button
                                type="button"
                                className="btn btn-primary w-md btn-md dropdown-toggle"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style={{ "marginLeft": "10px" }}
                            >
                                Action
                                <i className="mdi mdi-chevron-down"></i>
                            </button>
                        </div>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                sx: {
                                    boxShadow: '0px 0px 0px 0px rgba(0,0,0,1), 0px 0px 0px 1px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)',
                                    border: '1px solid #e0e0e0',
                                    outline: 'none',
                                    minWidth: '132px'
                                },
                                style: {
                                    border: '1px solid #fff',
                                }
                            }}
                        >

                            <MenuItem onClick={() => { handleClose(); setMessage("Edit"); setCreaterole(true); onloadedmetadata(selectedidData); isedit(true) }}>
                                Edit
                            </MenuItem>


                            {SelectedStatus === false ?
                                <MenuItem onClick={() => { handleClose(); ChangeStatus(SelectedId, true) }}>
                                    Activate
                                </MenuItem>
                                : <MenuItem onClick={() => { handleClose(); ChangeStatus(SelectedId, false) }}>
                                    Deactivate
                                </MenuItem>
                            }
                        </Menu>
                    </div>

                </>
            ),
        }
    ]


    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };
    const onSubmit = async (data) => {
        let req = {
            code: data.code,
            name: data.name,
            description: data.description || "",
            discount_type: data.discount_type,
            discount_value: data.discount_value,
            duration: data.duration,
            duration_months: data.duration === 'repeating' ? parseInt(data.duration_months) : null,
            max_redemptions: data.max_redemptions ? parseInt(data.max_redemptions) : null,
            max_per_user: data.max_per_user ? parseInt(data.max_per_user) : 1,
            minimum_amount: data.minimum_amount || "0.00",
            first_time_only: !!data.first_time_only,
            applies_to_topups: !!data.applies_to_topups,
            valid_from: data.valid_from ? new Date(data.valid_from).toISOString() : null,
            valid_until: data.valid_until ? new Date(data.valid_until).toISOString() : null,
            is_active: !!data.is_active,
            applies_to_plans: selectedPlans
        }
        if (edit) {
            try {
                const response = await axios.patch(`/api/admin/promo-codesv2/${SelectedId}/`, req)
                if (response.status === 200 || response.status === 201) {
                    triggerAlert('success', 'success', 'Promo Code updated Successfully!!');
                    handleModalClose();
                    fetchListData(currentPage)
                }
            } catch (err) {
                console.log(err?.response?.data?.message);
                triggerAlert('error', 'Error', err?.response?.data?.message || 'Something went wrong');
            }
        }
        else {
            try {
                const response = await axios.post('/api/admin/promo-codesv2/', req)
                if (response.status === 200 || response.status === 201) {
                    triggerAlert('success', 'success', 'Promo Code Added Successfully!!');
                    handleModalClose();
                    fetchListData(1)
                }
            } catch (err) {
                console.log(err?.response?.data?.message);
                triggerAlert('error', 'Error', err?.response?.data?.message || 'Something went wrong');
            }
        }
    };
    const access_privileges = JSON.parse(Cookies.get("modulepermissions"))
    const [customerlist, setcustomerlist] = useState(false)
    const [customeradd, setcustomeradd] = useState(false)
    const [customeredit, setcustomeredit] = useState(false)
    const [customerdelete, setcustomerdelete] = useState(false)
    useEffect(() => {
        fetchListData(1);
        access_privileges.map((access, i) => {
            access.sub_module_info.map((subaccess, k) => {
                if (subaccess.name === "Config" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true)
                }
                if (subaccess.name === "Config" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true)
                }
                if (subaccess.name === "Config" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true)
                }
                if (subaccess.name === "Config" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true)
                }

            })


        })
    }, []);

    const handleModalClose = () => {
        setCreaterole(false)
        setSelectedPlans([])
        resetForm()
        isedit(false)
        setSelectedId("")
    }

    const onloadedmetadata = (data) => {
        setSelectedId(data.id)
        setValueForm("code", data.code)
        setValueForm("name", data.name)
        setValueForm("description", data.description)
        setValueForm("discount_type", data.discount_type)
        setValueForm("discount_value", data.discount_value)
        setValueForm("duration", data.duration)
        setValueForm("duration_months", data.duration_months)
        setValueForm("max_redemptions", data.max_redemptions)
        setValueForm("max_per_user", data.max_per_user)
        setValueForm("minimum_amount", data.minimum_amount)
        setValueForm("first_time_only", data.first_time_only)
        setValueForm("applies_to_topups", data.applies_to_topups)
        setValueForm("valid_from", data.valid_from ? dayjs(data.valid_from).format('YYYY-MM-DDTHH:mm') : '')
        setValueForm("valid_until", data.valid_until ? dayjs(data.valid_until).format('YYYY-MM-DDTHH:mm') : '')
        setValueForm("is_active", data.is_active)

        // Handle applies_to_plans which might be array of objects or IDs
        if (Array.isArray(data.applies_to_plans)) {
            const planIds = data.applies_to_plans.map(p => typeof p === 'object' ? p.id : p);
            setSelectedPlans(planIds);
        } else if (typeof data.applies_to_plans === 'string') {
            setSelectedPlans(data.applies_to_plans.split(','));
        } else {
            setSelectedPlans([]);
        }
    }
    const handlePageChange = page => {
        fetchListData(page, perPage,);
        setCurrentPage(page);
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        fetchListData(page, newPerPage);
        setPerPage(newPerPage);
    };
    const ChangeStatus = async (data, isActive) => {
        let req = {
            is_active: isActive,
            is_deleted: !isActive
        }
        try {
            const response = await axios.patch(`/api/admin/promo-codesv2/${data}/`, req)
            if (response.status === 200 || response.status === 201) {
                fetchListData(currentPage)
                triggerAlert('success', 'success', 'Status updated Successfully!!');

            }
        } catch (err) {
            console.log(err?.response?.data?.message);
        }
    }
    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            {/* start page title */}
                            <PageHeader mainHeading={mainHeading} heading={heading} />
                            {/* end page title */}
                            <>
                                <div className="btn-group float-end col-md-1  ml-10 mb-3">
                                    <button type="button" className="btn btn-primary w-md btn-md  " onClick={() => { setSelectedPlans([]); setCreaterole(true); setMessage('Create'); resetForm(); isedit(false) }} style={{ "marginLeft": "10px" }}>
                                        Create Coupon
                                    </button>
                                </div>
                                {/* <div className="row">
                                    <form onSubmit={handleSubmitForm(onSubmit)}>
                                        <div className="d-flex justify-content-end mb-3">
                                            {!isEditing && (
                                                <button className="btn btn-dark radius-md rounded-circle" onClick={() => setIsEditing(true)}>
                                                    <i className="bx bx-edit" style={{ fontSize: "20px", marginTop: "3px" }}></i>
                                                </button>
                                            )}
                                        </div>

                                        <div className="row">
                                            <div className="form-group col-md-3 mb-3">
                                                <div className="mb-3">
                                                    <label htmlFor="per_user_cost" className="form-label">
                                                        Per User Cost(USD)<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        {...registerForm('per_user_cost', {
                                                            required: 'Per User Cost is required',
                                                            pattern: {
                                                                value: /^\d+(\.\d{1,2})?$/, 
                                                                message: 'Please enter a valid number',
                                                            },
                                                        })}
                                                        name="per_user_cost"
                                                        disabled={!isEditing}
                                                        onKeyUp={() => {
                                                            trigger("per_user_cost");
                                                        }}
                                                    />
                                                    {errorsForm.per_user_cost && (
                                                        <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                                                            {errorsForm.per_user_cost.message}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Test Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_test_cost', {
                                                        required: 'Per Test Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/, 
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_test_cost"
                                                    disabled={!isEditing}
                                                    onKeyUp={() => {
                                                        trigger("per_test_cost");
                                                    }}
                                                />
                                                {errorsForm.per_test_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_test_cost.message}</div>
                                                )}
                                            </div>

                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Resume Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_resume_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_resume_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_resume_cost");
                                                    }}
                                                />
                                                {errorsForm.per_resume_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_resume_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Agent Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_agent_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_agent_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_agent_cost");
                                                    }}
                                                />
                                                {errorsForm.per_agent_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_agent_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Call Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_call_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_call_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_call_cost");
                                                    }}
                                                />
                                                {errorsForm.per_call_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_call_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Minute Call Duration Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_minute_call_duration_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_minute_call_duration_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_resume_cost");
                                                    }}
                                                />
                                                {errorsForm.per_minute_call_duration_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_minute_call_duration_cost.message}</div>
                                                )}
                                            </div>
                                        </div>
                                        {isEditing && (
                                            <div className="py-2 mt-3">
                                                <div className="row">
                                                    <div className="col-12 text-end">
                                                        <button className='btn btn-warning w-md btn-md me-2' type="button" onClick={() => { handlecloseedit(); fetchListData(1); }}>Cancel</button>
                                                        <button className='btn btn-primary w-md btn-md' type="submit" disabled={!isEditing} >Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </form>
                                </div> */}
                                <DataTable
                                    columns={columns}
                                    data={Data}
                                    pagination
                                    paginationServer
                                    fixedHeaderScrollHeight='600px'
                                    fixedHeader
                                    persistTableHead
                                    paginationTotalRows={totalRows}
                                    customStyles={customStyles}
                                    // paginationPerPage={perPage}
                                    // paginationComponentOptions={paginationComponentOptions}
                                    // paginationDefaultPage={currentPage}

                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                />
                            </>

                            <Modal size='lg' show={Createrole} onHide={handleModalClose} className='modal fade' backdrop="static" keyboard={false}>
                                <Modal.Header className='modal-header_box bg-my-primary p-3 d-flex justify-content-between' closeButton>
                                    <h1 className="modal-title fs-5">{message} Promo Code</h1>
                                </Modal.Header>
                                <form onSubmit={handleSubmitForm(onSubmit)}>
                                    <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                        <div className="row">
                                            {/* Name */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Name <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("name", { required: "Name is required" })}
                                                    onKeyUp={() => trigger("name")}
                                                />
                                                {errorsForm.name && <div className="text-danger mt-1">{errorsForm.name.message}</div>}
                                            </div>

                                            {/* Code */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Coupon Code <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("code", {
                                                        required: "Coupon Code is required",
                                                        pattern: {
                                                            value: /^[A-Za-z0-9_-]*$/,
                                                            message: "Invalid characters in code",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger("code")}
                                                />
                                                {errorsForm.code && <div className="text-danger mt-1">{errorsForm.code.message}</div>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Discount Type */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Discount Type <span className="text-danger">*</span></label>
                                                <select className="form-select" {...registerForm("discount_type", { required: "Required" })}>
                                                    <option value="percentage">Percentage (%)</option>
                                                    <option value="fixed_amount">Fixed Amount</option>
                                                </select>
                                            </div>

                                            {/* Discount Value */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Discount Value <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("discount_value", {
                                                        required: "Value is required",
                                                        pattern: { value: /^\d+(\.\d{1,2})?$/, message: "Invalid value" }
                                                    })}
                                                    onKeyUp={() => trigger("discount_value")}
                                                />
                                                {errorsForm.discount_value && <div className="text-danger mt-1">{errorsForm.discount_value.message}</div>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Duration */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Duration <span className="text-danger">*</span></label>
                                                <select className="form-select" {...registerForm("duration", { required: "Required" })}>
                                                    <option value="once">Once</option>
                                                    <option value="repeating">Repeating</option>
                                                    <option value="forever">Forever</option>
                                                </select>
                                            </div>

                                            {/* Duration Months */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Duration Months</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    {...registerForm("duration_months")}
                                                    disabled={getValues("duration") !== 'repeating'}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Max Redemptions */}
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Max Redemptions</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    {...registerForm("max_redemptions")}
                                                />
                                            </div>

                                            {/* Max Per User */}
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Max Per User</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    {...registerForm("max_per_user")}
                                                />
                                            </div>

                                            {/* Minimum Amount */}
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Minimum Amount Required</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("minimum_amount")}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Valid From */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Valid From</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    {...registerForm("valid_from")}
                                                />
                                            </div>

                                            {/* Valid Until */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Valid Until</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    {...registerForm("valid_until")}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Description */}
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="2"
                                                    {...registerForm("description")}
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Plans Multi-Select */}
                                            <div className="col-md-12 mb-3 mt-2">
                                                <label className="form-label">Applies to Plans</label>
                                                <FormControl fullWidth size="small">
                                                    <Select
                                                        multiple
                                                        value={selectedPlans}
                                                        onChange={(e) => setSelectedPlans(e.target.value)}
                                                        input={<OutlinedInput />}
                                                        renderValue={(selected) => (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                {selected.map((value) => {
                                                                    const plan = plans.find(p => p.id === value);
                                                                    return <Chip key={value} label={plan ? plan.name : value} size="small" />;
                                                                })}
                                                            </div>
                                                        )}
                                                    >
                                                        {plans.map((plan) => (
                                                            <MenuItem key={plan.id} value={plan.id}>
                                                                <Checkbox checked={selectedPlans.indexOf(plan.id) > -1} />
                                                                <ListItemText primary={plan.name} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Checkboxes */}
                                            <div className="col-md-4 mb-3">
                                                <div className="form-check mt-2">
                                                    <input className="form-check-input" type="checkbox" id="first_time_only" {...registerForm("first_time_only")} />
                                                    <label className="form-check-label" htmlFor="first_time_only">First Time Only</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-check mt-2">
                                                    <input className="form-check-input" type="checkbox" id="applies_to_topups" {...registerForm("applies_to_topups")} />
                                                    <label className="form-check-label" htmlFor="applies_to_topups">Applies to Topups</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-check mt-2">
                                                    <input className="form-check-input" type="checkbox" id="is_active" {...registerForm("is_active")} />
                                                    <label className="form-check-label" htmlFor="is_active">Is Active</label>
                                                </div>
                                            </div>
                                        </div>
                                    </ModalBody>
                                    <Modal.Footer>
                                        <button className='btn btn-warning w-md btn-md me-2' type="button" onClick={handleModalClose}>Cancel</button>
                                        <button className='btn btn-primary w-md btn-md' type="submit">Save</button>
                                    </Modal.Footer>
                                </form>
                            </Modal>

                        </div> {/* container-fluid */}
                    </div>
                    {/* End Page-content */}
                    <Footer />
                </div>
                {/* end main content*/}

            </div>
            {/* END layout-wrapper */}

            {/* Right bar overlay*/}

        </>
    )

}
